import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const REMEMBER_ME_STORAGE_KEY = 'fusion-remember-me';

const getBrowserStorage = (storageName) => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window[storageName];
  } catch (_) {
    return null;
  }
};

const getPreferredStorage = () => {
  const localStorageRef = getBrowserStorage('localStorage');
  const sessionStorageRef = getBrowserStorage('sessionStorage');
  const rememberPreference = localStorageRef?.getItem(REMEMBER_ME_STORAGE_KEY);

  if (rememberPreference === 'false' && sessionStorageRef) {
    return sessionStorageRef;
  }

  return localStorageRef || sessionStorageRef;
};

const authStorage = {
  getItem(key) {
    const preferredStorage = getPreferredStorage();
    const localStorageRef = getBrowserStorage('localStorage');
    const sessionStorageRef = getBrowserStorage('sessionStorage');
    const fallbackStorage = preferredStorage === localStorageRef ? sessionStorageRef : localStorageRef;

    return preferredStorage?.getItem(key) ?? fallbackStorage?.getItem(key) ?? null;
  },
  setItem(key, value) {
    const preferredStorage = getPreferredStorage();
    const localStorageRef = getBrowserStorage('localStorage');
    const sessionStorageRef = getBrowserStorage('sessionStorage');

    preferredStorage?.setItem(key, value);

    if (preferredStorage !== localStorageRef) {
      localStorageRef?.removeItem(key);
    }

    if (preferredStorage !== sessionStorageRef) {
      sessionStorageRef?.removeItem(key);
    }
  },
  removeItem(key) {
    getBrowserStorage('localStorage')?.removeItem(key);
    getBrowserStorage('sessionStorage')?.removeItem(key);
  },
};

export const setRememberMePreference = (rememberMe) => {
  const localStorageRef = getBrowserStorage('localStorage');
  if (!localStorageRef) {
    return;
  }

  localStorageRef.setItem(REMEMBER_ME_STORAGE_KEY, rememberMe ? 'true' : 'false');
};

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL or Anon Key is missing. Check your .env file.');
  // Handle the error appropriately - maybe throw, or return a dummy client?
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: authStorage,
  },
});